import React from 'react';
import { WebFormPreview, RNPureConfigProvider } from '@shopee/chatbot-ui/rn';
import { getChatUIProviderConfig } from '@/utils/getChatUIProviderConfig';

export default (props: any) => {
  return (
    <RNPureConfigProvider {...getChatUIProviderConfig()}>
      <WebFormPreview {...props} />
    </RNPureConfigProvider>
  );
};
